import Model, { attr } from '@ember-data/model';
import { DbePlan } from 'uplisting-frontend/models/duda-configuration';

export default class DudaTemplateModel extends Model {
  @attr('string') name!: string;
  @attr('string') previewUrl?: string;
  @attr('string') thumbnailUrl?: string;
  @attr('string') tier!: DbePlan;
  @attr('boolean') default!: boolean;
  @attr('boolean') available!: boolean;

  get isPlusOnly(): boolean {
    return this.tier === DbePlan.plus;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'duda-template': DudaTemplateModel;
  }
}
